<script>
    import { onMount } from 'svelte';
    import { auth, db, user } from './stores.js';
    import SignIn from './components/SignIn.svelte';
    let filterBy = "all";
    let mode = "tutorials";
    let url;
    let keyword1, keyword2, keyword3, keyword4, keyword5;
    let status = "";
    let userSocial;
    let tutorials=[];
    let keywordsSet;
    let keywordFilters;

    $: keywords = [keyword1, keyword2, keyword3, keyword4, keyword5].filter(keyword => keyword).map(keyword => keyword.toLowerCase());
    // $: tutorialsFiltered = tutorials;
    $: tutorialsFiltered = filterBy === "all" ? tutorials : tutorials.filter(tutorial => tutorial.keywords.includes(filterBy));
    $: filters = keywordsSet ? Array.from(keywordsSet).sort() : [];
    onMount(async () => {
        $db.collection("tutorials").where("status", "==", "active")
            .onSnapshot((querySnapshot) => {
                tutorials = [];
                let filterArray = [];
                querySnapshot.forEach((doc) => {
                    tutorials = [...tutorials, doc.data()];
                    filterArray = [...filterArray, ...doc.data().keywords]
                });
                console.log("active tutorials: ", tutorials);
                console.log("filterArray: ", filterArray);
                keywordsSet = new Set(filterArray);
            });

        if ($user){
            loadInfo($user.uid);
        }
    });

	$auth.onAuthStateChanged(function(userAuthState) {
		if(userAuthState){
            loadInfo(userAuthState.uid);
		} else {
			// console.log('onAuthStateChanged no user');
			// $user = null;
		};
	});

    function loadInfo(uid) {
        // get logged in social account
        $db.collection("users").doc(uid).get().then((doc) => {
            if (doc.exists) {
                console.log("User data: ", doc.data());
                userSocial = {...doc.data()}
                console.log("userSocial: ", userSocial);

            } else {
                console.error("No such document");
            }
        }).catch((error) => {
            console.log("Error getting document: ", error);
        });
    };

    function submitTutorial(){
        console.log('keywords: ', keywords);
        $db.collection("tutorials").add({
            url,
            keywords,
            status: "pending",
            provider: userSocial.provider,
            username: userSocial.username
        }).then((docRef) => {
            status = "Tutorial submitted. Thank you!"
        }).catch((error) => {
            status = `Error: ${error}`;
        });

    };

</script>

<main>
    <div id="controls">
        {#if $user && $user.isBanned}
            <span></span>
        {:else}
            <button on:click="{() => mode='add'}">add a tutorial</button>
        {/if}
        <fieldset>
            <legend>filter</legend>
        
            <label for="all">
                <input type="radio" bind:group={filterBy} value={"all"} id="all" name="filterBy">
                all
            </label><br/>
            {#each filters as filter}
                <label for={filter}>
                    <input type="radio" bind:group={filterBy} value={filter} id={filter} name="filterBy">
                    {filter}
                </label><br/>
            {/each}
        </fieldset>
    </div>
    <div id="content">
        {#if mode==="tutorials"}
            <div id="disclaimer"><strong>DISCLAIMER:</strong> I'm a JavaScript Developer Advocate at <a href="https://developer.vonage.com" target="_blank">Vonage</a>. There are Vonage tutorials because I think they are cool and I probably worked on them. So if you have any questions, hit me up.</div>
            <div id="container">
                {#if tutorialsFiltered.length === 0 }
                    <div>loading tutorials</div>
                {:else}
                    {#each tutorialsFiltered as tutorial}
                        <div class="card">
                            {tutorial.title}
                            <p class="description">{tutorial.description}</p>
                            <hr>
                            <br/>submitted by:
                            <br/><a href="https://{tutorial.provider}/{tutorial.username}" target="_blank">{tutorial.username}</a>
                            <br/><a class="button" href={tutorial.url} target="_blank">view tutorial</a>
                        </div>
                    {/each}
                {/if}
            </div>
        {:else}
            {#if $user}
                {#if $user.isBanned}
                    <span></span>
                {:else}
                    url: <input bind:value={url} placeholder="https://example.com">
                    <br/>keywords:
                    <br/><input bind:value={keyword1} placeholder="keyword">
                    <br/><input bind:value={keyword2} placeholder="keyword">
                    <br/><input bind:value={keyword3} placeholder="keyword">
                    <br/><input bind:value={keyword4} placeholder="keyword">
                    <br/><input bind:value={keyword5} placeholder="keyword">

                    <br/><button on:click={submitTutorial}>submit</button>
                    <br/>{status}
                {/if}
            {:else}
                <div>
                    Please log in before submitting a tutorial.
                    <SignIn />
                </div>
            {/if}
            <br/><br/><br/><button on:click="{() => mode='tutorials'}">back to tutorials</button>
        {/if}
    </div>
</main>

<style>
    main {
        height: 100%;
        width: 100%;
        max-width: 1500px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin: auto;
    }

    fieldset {
        text-align: left;
    }

    legend {
        background-color: #000;
        color: #fff;
        padding: 3px 6px;
    }

    input {
        margin: .4rem;
    }

    label {
        display: inline-block;
    }

    #controls {
        width: 300px;
        margin: 10px;
    }
    #content {
        width: 100%;
        overflow-y: auto;
        height: calc( 100vh - 57px );
    }

    button {
        cursor: pointer;
    }

    #container {
        display: grid;
        grid-gap: 1rem;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    }

    .card {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 1rem;
        border: 1px solid black;
    }

    .description {
        -webkit-line-clamp: 3;
        overflow: hidden;
    }

    #disclaimer {
        /* position: absolute; */
        max-width: 1000px;
        /* top: 0; */
        padding: 10px;
        margin: auto;
    }

    .button {
        padding: 5px;
        border: 2px solid black;
        text-decoration: none;
    }
    a {
        text-decoration: underline;
    }
</style>